import { Box, Typography } from '@mui/material';
import { useState, useEffect, FC } from 'react';

interface Props {
	datehour: string;
}

const parseDateTime = (dateTimeString: string) => {
	if (!dateTimeString) return null;

	const parts = dateTimeString.split(' ');
	if (parts.length !== 2) return null;

	const [datePart, timePart] = parts;
	const dateParts = datePart.includes('-')
		? datePart.split('-').map(Number)
		: datePart.split('/').map(Number);
	const timeParts = timePart.split(':').map(Number);

	if (dateParts.length !== 3 || timeParts.length !== 3) return null;

	let year;
	let month;
	let day;
	if (datePart.includes('-')) {
		[year, month, day] = dateParts;
	} else {
		[day, month, year] = dateParts;
	}

	const [hours, minutes, seconds] = timeParts;
	const parsedDate = new Date(year, month - 1, day, hours, minutes, seconds);
	return isNaN(parsedDate.getTime()) ? null : parsedDate.getTime();
};

const calculateTimeLeft = (targetTime: number | null) => {
	if (!targetTime) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

	const now = new Date().getTime();
	const difference = targetTime - now;

	if (difference <= 0) {
		return false;
	}

	return {
		days: Math.floor(difference / (1000 * 60 * 60 * 24)),
		hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
		minutes: Math.floor((difference / (1000 * 60)) % 60),
		seconds: Math.floor((difference / 1000) % 60),
	};
};

export const CountdownTimer: FC<Props> = ({ datehour }) => {
	const targetTime = parseDateTime(datehour);
	const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetTime));

	useEffect(() => {
		if (!timeLeft) return;
		if (!targetTime) return;

		const timer = setInterval(() => {
			setTimeLeft(calculateTimeLeft(targetTime));
		}, 1000);

		return () => clearInterval(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [targetTime]);

	if (!targetTime) {
		return null;
	}

	if (!timeLeft) return null;

	return (
		<Box
			sx={{
				color: 'white',
				width: '150px',
				'@media (max-width: 600px)': { flexDirection: 'column', fontSize: '13px' },
				'@media (min-width: 768px)': { flexDirection: 'row', fontSize: '13px' },
			}}
		>
			<Box />

			<Box
				sx={{
					display: 'flex',
					justifyContent: { xs: 'center', md: 'flex-end' },
					fontWeight: 'bold',
					marginRight: { xs: '0px', md: '2%' },
					width: '130px',
				}}
			>
				{timeLeft !== true ? (
					<Box sx={{ color: '#011688' }}>
						<Typography component="span" sx={{ color: 'white' }}>
							{timeLeft.days}
						</Typography>{' '}
						{'D '}
						<Typography component="span" sx={{ color: 'white' }}>
							{timeLeft.hours}
						</Typography>{' '}
						{'H '}
						<Typography component="span" sx={{ color: 'white' }}>
							{timeLeft.minutes}
						</Typography>{' '}
						{'M '}
						<Typography component="span" sx={{ color: 'white' }}>
							{timeLeft.seconds}
						</Typography>{' '}
						{'S'}
					</Box>
				) : null}
			</Box>
		</Box>
	);
};
